import * as PIXI from 'pixi.js-legacy';
import InnerDropArea from '../InnerDropArea';
import DynamicProppingAncestor from '../DynamicProppingAncestor';
import productService from '../../services/products';
import addItem from '../../state/tac/tacReducer/addItem';
import updateDependentItems from '../../state/tac/tacReducer/updateDependentItems';
import updateItem from '../../state/tac/tacReducer/updateItem';
import geometry from '../util/geometry';
import tacHelpers from '../../state/tac/tacHelpers';

export default class Section extends DynamicProppingAncestor {
  update(args) {
    super.update(args);
    this.childrenContainer &&
      this.childrenContainer.children.forEach(child => {
        if (
          child.item &&
          productService.isType(child.item, ['side-panel', 'end-shelf'])
        ) {
          child.interactive = false;
        }
      });
  }

  draw() {
    super.draw();

    this.sprite.visible = !tacHelpers.isWithinWall(this.item, this.app.tac);
    const { scaledVertices } = this.data;

    this.rightDropAreas = this.rightDropAreas || new PIXI.Container();
    this.rightDropAreas.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.rightDropAreas.parent) {
      this.addChildAt(
        this.rightDropAreas,
        this.getChildIndex(this.childrenContainer)
      );
    }
  }

  drawDropAreas(slots) {
    slots = slots.filter(slot => slot.parent.itemid === this.item.itemid);

    const width = Math.floor(this.data.faceSize.width * this.ratio) - 2;
    const localItem = {
      ...this.item,
      x: 0,
      y: 0,
    };

    slots.forEach(slot => {
      const localSlot = { ...slot, ...slot.local };

      if (
        geometry.extendsOutside(localSlot, localItem) &&
        localSlot.y < localItem.height
      ) {
        const width = localSlot.partnerSlot
          ? localSlot.partnerSlot.x + localSlot.partnerSlot.width - slot.x
          : localSlot.width;
        const sprite = new InnerDropArea({
          width: width * this.ratio,
          height: localSlot.height * this.ratio,
          ratio: this.ratio,
          slot: localSlot,
        });

        sprite.slot = localSlot;

        // FIXME: This shouldn't really be an InnerDropArea, but since it is
        // we need to adjust for the POST_WIDTH offset that's added to all InnerDropAreas
        sprite.x = (localSlot.x - productService.getPostWidth()) * this.ratio;
        sprite.y =
          (this.item.height - (localSlot.y + localSlot.height)) * this.ratio;

        this.rightDropAreas.addChild(sprite);
      } else {
        const sprite = super.getDropAreaSprite(localSlot, width);
        sprite && this.dropAreas.addChild(sprite);
      }
    });
  }

  displayDropAreas(slot) {
    this.displayDropArea(this.rightDropAreas, slot);
    this.displayDropArea(this.dropAreas, slot);
  }

  eraseDropAreas() {
    this.rightDropAreas.removeChildren();
    super.eraseDropAreas();
  }

  /**
   * Updates the dependents of a specific section during a dragging event
   * @param {*} newItem
   * @returns {undefined}
   */
  updateDependentItemsDragging(newItem) {
    let updatedTac;

    if (newItem.itemid) {
      const hadPanel = this.app.dragging.originalItem.items.some(item =>
        productService.isType(item, 'side-panel')
      );
      updatedTac = updateItem(this.app.tac, newItem);
      if (hadPanel) {
        updatedTac = updateDependentItems(updatedTac, {
          triggerItem: this.app.dragging.originalItem,
        });
      }
    } else {
      // when dragging from swiper
      updatedTac = addItem(this.app.tac, newItem);

      // a new sprite will be created from the tmp item added to the fake tac,
      // so let's detach from our parent to avoid a conflict
      this.app.itemContainer.removeChild(this);
    }

    this.app.itemContainer.update({
      room: this.app.room.model,
      options: this.app.itemContainerOptions,
      ratio: this.app.room.ratio,
      tac: updatedTac,
      updateOrigo: false,
    });
  }
}
